import { AdminModal } from 'shared/adminModal/AdminModal';
import styled from 'styled-components';
import {
  media, textAlignCenter, truncate,
} from 'utils/styledHelpers';

interface StyledViewModalDetailsRowProps {
    $allowWrap?: boolean;
}
interface StyledModalBiggerProps {
    $mdPaddings?: boolean;
}
interface StyledConfigureModalProps {
    $mdPaddings?: boolean;
    $isSmallSize?: boolean;
}
interface SaveDiscardButtonsGroupProps {
    $isCenter?: boolean;
}
interface StyledModalRightProps {
    $fullWidth?: boolean;
}
interface StyledTotalPlayersProps {
    $isActive?: boolean;
}
interface StyledModalInvalidBluePlayersProps {
    $isActive?: boolean;
    $noPadding?: boolean
}

interface StyledModalProps {
    $mdPaddings?: boolean;
    $minHeight?: string;
    $isSticky?: boolean;
}

const StyledModal = styled(AdminModal)<StyledModalProps>`
  color: ${(props) => props.theme.colors.primaryText};
  .ant-modal-container {
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
    padding: 0;
  }
  .ant-upload.ant-upload-drag {
    background: none;
    border: none;
  }
  .ant-upload.ant-upload-drag .ant-upload {
    padding: 0;
  }
  .ant-upload.ant-upload-drag .ant-upload &.autoModal {
    max-height: unset;
    .ant-modal-footer {
      justify-content: center;
      padding-top: 0;
    }
    .ant-modal-close {
      top: 16px;
    }
  }
  &.confirm-modal {
    .ant-modal-footer {
      justify-content: center;
    }
    .ant-modal-footer {
      position: static;
      padding: 1.71rem 3.43rem 1.71rem;
      margin-top: 0;
      ${media.sm`
        padding: 0 1.4rem 1.4rem;    
      `}
    }
    .ant-modal-body {
      padding: 2.85rem 3.43rem 1.17rem;
      ${media.sm`
        padding: ${(props) => (props.$mdPaddings ? '2.85rem 1.4rem 1.4rem' : '2.85rem 1.4rem 1.71rem')};    
      `}
    }
    .ant-modal-close {
      top: 10px;
    }
  }
  .ant-modal-container {
    background-color: ${(props) => props.theme.colors.selectBg};
    box-shadow: 0 3px 6px #00000016;
  }

  .ant-modal-close {
    top: 1rem;
    right: 1.14rem;
    width: 22px;
    height: 22px;
    &:hover,
    &:focus {
      background-color: transparent;
    }
    .ant-modal-close-x {
      width: initial;
      height: initial;
    }
  }

  .ant-modal-body {
    min-height: ${(props) => props.$minHeight && props.$minHeight};
    padding: ${(props) => (props.$mdPaddings ? '3.43rem' : '3.43rem 3.43rem 0')};
    max-height: calc(100vh - 164px);
    overflow-y: auto;
    overflow-x: hidden;
    ${media.sm`
      padding: ${(props) => (props.$mdPaddings ? '3.45rem 1.4rem' : '3.45rem 1.4rem 0')};      
    `}
      margin-bottom: auto;
      
  }

  .ant-modal-footer {
    border: initial;
    padding: 1rem 3.43rem 2rem;
    margin-top: 1.71rem;
    position: sticky;
    bottom: -1rem;
    background-color: ${(props) => props.theme.colors.secondaryBg};
    border-radius: 0 0  ${(props) => props.theme.customBorderRadius.borderRadiusMiddle} ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
    &:empty {
      display: none;
    }
  }
  .ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
    margin-left: 1.14rem;
  }
  .ant-modal-header {
    border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
    padding: 0.57rem 1.71rem;
    min-height: 3.43rem;
    background-color: transparent;
    display: flex;
    align-items: center;
    margin-bottom: 0;
    .ant-modal-title {
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      color: ${(props) => props.theme.colors.primaryText};
      font-size: ${(props) => props.theme.typography.fontSizeMiddle};
      user-select: none;
    }
  }
  .ant-card-meta-description {
    color: ${(props) => props.theme.colors.primaryText};
  }
  .ant-form-item-control-input-content textarea.ant-input {
    height: 156px;
    padding: 1.14rem;
    resize: none;
  }
  .ant-calendar-range-picker-input {
    width: 100px;
    text-align: left;
  }
  .ant-calendar-range-picker-separator {
    vertical-align: initial;
    padding: 0 20px 0 0;
  }
`;

const StyledImageSourcePickerModal = styled(StyledModal)`
  .ant-modal-body {
    padding: 1rem 1.7rem;

    ${media.sm`
      padding: 0.725rem 1rem;      
    `}
  }
  .ant-tabs-content {
    min-height: 550px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .ant-tabs-tabpane {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .ant-form {
    flex-grow: 1;
  }
`;

const StyledViewModalDetailsRow = styled.div<StyledViewModalDetailsRowProps>`
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: ${(props) => (props.$allowWrap ? 'wrap' : 'nowrap')};
  gap: 0.72rem;
  justify-content: space-between;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.primaryText};

  span:first-child {
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  }
  a {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${(props) => props.theme.colors.blue};
    &:hover {
      color: ${(props) => props.theme.colors.blue};
      text-decoration: underline;
    }
  }
`;

const StyledViewModalDetailsUrl = styled.div`
  display: flex;
  span {
    margin-right: 0.57rem;
    svg {
      cursor: pointer;
      &:hover {
        path {
          fill: ${(props) => props.theme.colors.hover};
        }
      }
    }
  }
`;

const StyledModalBig = styled(StyledModal)`
  min-height: 58%;
  .ant-modal-close {
    display: block;
  }
  .ant-modal-body {
    padding: 0;
    display: flex;
  }
  .ant-table-thead > tr:hover.ant-table-row-selected > td,
  .ant-table-tbody > tr:hover.ant-table-row-selected > td {
    background-color: transparent;
  }
  .ant-checkbox + span {
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
    color: ${(props) => props.theme.colors.primaryText};
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  }
`;

const StyledModalBigger = styled(StyledModal)<StyledModalBiggerProps>`
  height: 92%;
  &.ant-modal {
    padding-bottom: 0;
  }
  .ant-modal-header,
  .ant-modal-footer {
    flex-shrink: 0;
  }
  .ant-modal-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    padding: ${(props) => (props.$mdPaddings ? '2.85rem 3.43rem' : '2.86rem 3.43rem 0')};
    .ant-form {
      height: initial;
    }
  }
  .ant-checkbox + span {
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
    color: ${(props) => props.theme.colors.primaryText};
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  }
`;

const StyledConfigureModal = styled(StyledModalBigger)<StyledConfigureModalProps>`
  .ant-modal-body {
    display: flex;
    flex-direction: ${(props) => (props.$isSmallSize ? 'column' : 'row')};
    align-items: ${(props) => (props.$isSmallSize ? 'center' : 'flex-start')};
    padding: ${(props) => (props.$isSmallSize ? '1.16rem' : '3.43rem 3.43rem 0')};
    flex-wrap: wrap;
    flex-grow: 0;
      
    & > .ant-form {
      width: 100%;
    }

    ${media.sm`
      padding: ${(props) => (props.$mdPaddings ? '1.4rem' : '1.4rem 1.4rem 0')};      
    `}
  }
  .ant-modal-footer {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;
const StyledConfigureModalInfoWrapper = styled.div`
  flex: 0 0 100%;
`;

const StyledModalQuestion = styled.div`
  ${textAlignCenter()};
  color: ${(props) => props.theme.colors.primaryText};
  line-height: 1.71rem;
  font-size: 1rem;
  .ant-modal-container {
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
  }
`;

const SaveDiscardButtonsGroup = styled.div<SaveDiscardButtonsGroupProps>`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.$isCenter ? 'center' : 'flex-end')};
  .ant-btn {
    height: 2.57rem;
    font-size: 1rem;
  }
`;

const TableTdDistance = styled.section`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -0.5rem;
  display: flex;
  > span {
    margin-left: 1.25rem;
  }
`;
const CommsComposeModalStyle = styled(StyledModal)`
  padding-bottom: 0;

  .ant-modal-container {
    height: 100%;
    .ant-modal-body {
      padding: 2.29rem 2.5rem 3.14rem;
      max-height: 86vh;
      overflow: auto;

      ${media.xs`
        padding: 2.29rem 0.71rem 3.14rem;
      `}
    }
  }
`;
const StyledModalForm = styled.div`
  .has-error .ant-form-explain {
    top: 37px;
  }
  .ant-form-item-children {
    display: block;
    height: 36px;
  }
  .ant-form-item {
    padding-bottom: 2rem;
  }
  .ant-form-vertical .ant-form-item-label > .ant-form-item-required:after,
  .ant-form-horizontal .ant-form-item-label > .ant-form-item-required:after {
    color: ${(props) => props.theme.colors.secondaryColor};
  }
  .ant-modal-container {
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
  }
`;

const StyledModalLeft = styled.div`
  width: calc(50% - 2.86rem);
  flex: 0 0 calc(50% - 2.86rem);
  margin-right: 2.86rem;

  ${media.xs`
    width: 100%;
    flex: 0 0 100%;
    margin: 0 0 3rem;
  `}
`;

const StyledModalRight = styled.div<StyledModalRightProps>`
  width: ${(props) => (props.$fullWidth ? '100%' : '50%')};
  flex: 0 0 ${(props) => (props.$fullWidth ? '100%' : '50%')};

  ${media.xs`
    width: 100%;
    flex: 0 0 100%;
  `}

  > div {
    width: auto;
  }
`;

const StyledRightModalBorderBottomHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  padding: 0.1rem 1.7rem 0.5rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.primaryBorder};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-size: ${(props) => props.theme.typography.fontSizeDefault};
  color: ${(props) => props.theme.colors.primaryText};
`;
const StyledTotalPlayers = styled.div<StyledTotalPlayersProps>`
  font-size: ${(props) => props.theme.typography.fontSizeMiddle};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => (!props.$isActive ? props.theme.colors.primaryText : props.theme.colors.blue)};
  &:hover {
    color: ${(props) => props.theme.colors.blue};
    text-decoration: ${(props) => (props.$isActive ? '' : 'underline')};
  }
  cursor: ${(props) => (props.$isActive ? 'initial' : 'pointer')};
`;

const StyledModalInvalidBluePlayers = styled.div<StyledModalInvalidBluePlayersProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${(props) => props.theme.typography.fontSizeDefault};
  color: ${(props) => props.theme.colors.primaryText};
  ${(props) => !props.$noPadding && 'padding-right: 1.71rem;'}
  > span {
    &:first-child {
      background: ${(props) => (props.$isActive ? props.theme.colors.blue : `${props.theme.colors.blue}20`)};
      color: ${(props) => (props.$isActive ? props.theme.colors.white : props.theme.colors.primaryText)};
      cursor: ${(props) => (props.$isActive ? 'initial' : 'pointer')};
      padding: 0.43rem 1.14rem;
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      transition: 0.2s all;
    }
  }
`;

const StyledAllModalTable = styled.div`
  .ant-table-cell.ant-table-cell-scrollbar {
    display: none;
  }
  .ant-spin-container .ant-pagination {
    padding-bottom: 0;
  }
  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }
  .ant-table .ant-table-thead {
    background: none;
    > tr > th {
      background: none;
    }
  }
  height: calc(100% - 2rem);
  a {
    color: ${(props) => props.theme.colors.blue};
  }
  .ant-checkbox-wrapper {
    display: inline-flex !important;
    margin-top: 5px;
  }
  .ant-table-empty {
    .ant-table-header {
      display: none;
    }
    & .ant-table-tbody > tr:last-child:not(.ant-table-expanded-row):not(.partners-brands-row):not(.permission-row) > td {
      border-bottom: none !important;
    }
    .ant-empty-normal {
      margin-right: 1.79rem;
    }
  }
`;

const StyledModalColumn = styled.div`
  text-align: center;
  display: flex;
  justify-content: flex-start;

  > div {
    > div {
      background: ${(props) => props.theme.colors.primaryBg};
      border: 1px solid ${(props) => props.theme.colors.primaryBorder};
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      width: max-content;
      max-width: 6.78rem;
      padding: 0 0.27rem;
      height: 2rem;
      line-height: 2rem;
      margin-right: 0.57rem;
      ${truncate()}
    }
    > span {
      height: calc(100% - 0.71rem);
    }
  }
`;
const StyledModalTab = styled.div`
  .ant-tabs-tab-active {
    border-bottom: none;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      bottom: 0;
      left: 0;
      background: ${(props) => props.theme.colors.blue};
    }
  }
  .ant-tabs-tab-btn {
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  }

  .ant-tabs-tab {
    padding: 0 0.85rem 0.85rem;
  }
`;
const StyledModalSearch = styled.div`
  margin: 1rem 0 0.43rem;
  > div {
    width: 100%;
  }
  .ant-select .ant-select-selector {
    padding-right: 0;
  }
  .ant-space-compact.ant-input-search {
    height: 2.57rem;
    .ant-input-search-icon::before {
      display: none;
    }
  }
  .ant-input {
    background: transparent;
  }
`;
const RightSearchFieldForModals = styled.div`
  .ant-input-search {
    margin: 1.4rem 0 0;
  }
`;
const CustomLabel = styled.p`
  color: ${(props) => props.theme.colors.primaryText};
  font-size: ${(props) => props.theme.typography.fontSizeDefault};
  margin-bottom: 0.57rem;
`;

const StyledBulkUploadList = styled.div`
  position: relative;
  display: inline-block;
`;

const StyledWithCheckboxModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .ant-checkbox + span {
    font-size: 1rem;
  }
`;
const StyledAllPlayerTabs = styled.div`
  > div:not(:last-child) {
    margin-bottom: 0.85rem;
  }
  margin-top: 0.71rem;
`;

const StyledViewTableInModal = styled.div`
  padding-bottom: 3.42rem;
`;

const StyledSmallModal = styled(StyledModal)`
  .ant-modal-body {
    padding: 2.42rem 2.42rem 0;
    ${media.sm`
      padding: 2rem 1.4rem;      
    `}
  }
`;

const StyledModalDividerWrapper = styled.div`
  margin-top: 1.43rem;
`;

const StyledDashboardBody = styled.div`
  display: flex;
  width: 100%;
  max-height: calc(100vh - 280px);
`;

const StyledWidgetsModal = styled(StyledModal)`
  .ant-modal-body {
    margin-top: 3.42rem;
    padding-top: 0;
    max-height: calc(100vh - 220px);
  }
`;

export {
  StyledModal,
  StyledModalSearch,
  StyledModalBig,
  StyledModalBigger,
  StyledModalQuestion,
  StyledModalTab,
  StyledViewModalDetailsRow,
  StyledViewModalDetailsUrl,
  SaveDiscardButtonsGroup,
  TableTdDistance,
  StyledConfigureModal,
  StyledConfigureModalInfoWrapper,
  CommsComposeModalStyle,
  StyledModalForm,
  StyledModalLeft,
  StyledModalRight,
  StyledAllModalTable,
  StyledModalColumn,
  StyledRightModalBorderBottomHeading,
  StyledModalInvalidBluePlayers,
  RightSearchFieldForModals,
  CustomLabel,
  StyledTotalPlayers,
  StyledWithCheckboxModal,
  StyledBulkUploadList,
  StyledAllPlayerTabs,
  StyledViewTableInModal,
  StyledSmallModal,
  StyledModalDividerWrapper,
  StyledImageSourcePickerModal,
  StyledDashboardBody,
  StyledWidgetsModal,
};
